import { useIsOnline } from "./useIsOnline";

export function useIsOffline(): boolean {
  return !useIsOnline();
}
